import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useOrgUsers = (
  params: { include_staff?: boolean; agency_id?: number } = { include_staff: false },
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [{ entity: "orgUsers", params }],
    queryFn: async () => await apiClient.getOrgUsers({ queries: params }),
    ...options,
  });
};
